// Unified risk level constant for all customers and documents.
// Under the hood, uses a combination of agents and trust score to determine the
// risk level.

export enum RiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export const RISK_LEVEL = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const getTopRiskLevel = (fraudSummary) => {
  const priority = [
    RISK_LEVEL.HIGH,
    RISK_LEVEL.MEDIUM,
    RISK_LEVEL.LOW,
    RISK_LEVEL.NOT_APPLICABLE,
  ];
  const obj = fraudSummary?.aggregated_risk_counts;
  return obj && priority.find((key) => obj[key] > 0);
};

export const riskLevelToReadableLabel = (riskLevel) => {
  switch (riskLevel) {
    case RISK_LEVEL.HIGH:
      return 'High Risk';
    case RISK_LEVEL.MEDIUM:
      return 'Medium Risk';
    case RISK_LEVEL.LOW:
      return 'Low Risk';
    case RISK_LEVEL.NOT_APPLICABLE:
      return 'Not Applicable';
    default:
      return '';
  }
};
